import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import { Modal, Button } from 'antd'; // Import Modal and Button from Ant Design
import './Offer.css'; // Ensure this CSS file is updated for proper styling

function Offers() {
  const [products, setProducts] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false); // State for image modal visibility
  const [currentImage, setCurrentImage] = useState(''); // State for current image
  const [currentProductId, setCurrentProductId] = useState(''); // State to store the product id
  const navigate = useNavigate(); // Initialize navigate function

  useEffect(() => {
    const fetchProducts = async () => {
      const q = query(collection(db, 'products'), orderBy('timestamp', 'desc')); // Order by newest first
      const querySnapshot = await getDocs(q);
      const productsData = querySnapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .filter((product) => product.discount >= 1); // Filter products with a discount of 1% or more
      setProducts(productsData);
    };

    fetchProducts();
  }, []);

  const calculateDiscountedPrice = (price, discount) => {
    return price - (price * discount) / 100;
  };

  const handleImageClick = (productId, imageUrl) => {
    setCurrentImage(imageUrl);
    setCurrentProductId(productId);
    setIsModalVisible(true); // Show the image modal
  };

  const handleProductClick = (productId) => {
    navigate(`/product-details/${productId}`); // Navigate to the product details page
  };

  const handleOk = () => {
    navigate(`/product-details/${currentProductId}`); // Navigate to the product details page when user clicks OK
    setIsModalVisible(false); // Close the modal
  };

  const handleCancel = () => {
    setIsModalVisible(false); // Close the modal when user clicks Cancel
  };

  return (
    <div className="off-container">
      <h2 className="off-title" style={{ color: 'orange' }}>Offers</h2>
      
    
      <div className="offe-scroller">
        {products.map((product) => {
          const newPrice = calculateDiscountedPrice(product.price, product.discount);
          return (
            <div
              className="off-card"
              key={product.id}
              onClick={() => handleProductClick(product.id)} // Navigate to product details when card is clicked
            >
              <img
                src={product.image}
                alt={product.title}
                className="off-image"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent navigating when image is clicked
                  handleImageClick(product.id, product.image); // Show image modal
                }}
              />
              <div className="off-info">
                <h3 className="off-title">{product.title}</h3>
                <p className="off-price">
                  <span className="original-price">Ksh. {product.price}</span>
                  <span className="new-price"> Ksh. {newPrice.toFixed(2)}</span>
                </p>
                <p className="off-discount">{product.discount}%  Off</p>
              </div>
            </div>
          );
        })}
      </div>

      {/* Image Modal */}
      <Modal
        title="Product Image"
        visible={isModalVisible}
        onOk={handleOk} // Navigate to product details when OK is clicked
        onCancel={handleCancel} // Close modal when Cancel is clicked
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleOk}>
            View Details
          </Button>,
        ]}
      >
        <img src={currentImage} alt="Product" style={{ width: '100%', height: 'auto' }} />
      </Modal>
    </div>
  );
}

export default Offers;
